import { forwardRef, useState } from 'react'
import { appUrl } from '@astro/config'

const ProductCard = forwardRef(function ProductCard({ product, onView }, ref) {
  const [imgFailed, setImgFailed] = useState(false)

  // Product detail lives in the shop app (/products/:slug).
  const productHref = appUrl('shop', `products/${product.slug ?? product.id}`)

  return (
    <article className="ps-card" ref={ref} data-ps-cat={product.category} aria-label={product.name}>
      <div className="ps-img-wrap">
        {!imgFailed ? (
          <img src={product.image} alt={product.name} loading="lazy" onError={() => setImgFailed(true)} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5EDD8', fontSize: '40px', opacity: 0.4 }}>
            💎
          </div>
        )}
        <span className={`ps-badge ${product.badgeClass}`}>{product.badgeLabel}</span>
        <div className="ps-img-overlay" />
      </div>
      <div className="ps-body">
        <div className="flex items-center justify-between mb-2">
          <span style={{ fontSize: '8.5px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.12em', color: '#B08040' }}>
            {product.origin ? `⛰ ${product.origin} Origin` : '✦ Sacred Collection'}
          </span>
          <span className="ps-verified">⬡ Lab Verified</span>
        </div>
        <h3 className="ps-name">{product.name}</h3>
        <p className="ps-desc">{product.description}</p>
        {product.tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-3">
            {product.tags.map((tag) => (
              <span key={tag} className="ps-micro-badge">
                {tag}
              </span>
            ))}
          </div>
        )}
        <div className="ps-divider" />
        <div className="flex items-center justify-between mt-3 mb-3">
          <div>
            <div style={{ fontSize: '7.5px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.14em', color: '#B08040', marginBottom: '2px' }}>
              System Price
            </div>
            <div className="ps-price">{product.price}</div>
          </div>
          <div className="ps-avail" style={product.available ? undefined : { color: '#B91C1C' }}>
            <span className="ps-dot-green" style={product.available ? undefined : { background: '#B91C1C', boxShadow: 'none' }} />
            {product.available ? 'Available' : 'Out of Stock'}
          </div>
        </div>
        <div className="flex gap-2">
          <a href={productHref} className="ps-btn-primary" style={{ textAlign: 'center' }}>
            View Details
          </a>
          {/* <button type="button" className="ps-btn-ghost" onClick={onView}>
            Enquire
          </button> */}
        </div>
      </div>
    </article>
  )
})

export default ProductCard
